import React, { useState, useEffect, useMemo, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getFormatDate, getTodayDate } from "utils/DateUtil";
import { callPost, ConstantsServer, callPostAsync } from "utils/CommonApi";

import LnbMainWrapper from "./wrapper/LnbMainWrapper";
import Fl from "./wrapper/Fl";
import FlContent from "./wrapper/FlContent";
import Menu from "./menu/Menu";
import ToggleButton from "./toggleButton/ToggleButton";

import { launchWebView, closeApp } from "bridge/common/CommonBridge";

import Constants from "common/Constants";

import menuLinkTrimmer from "utils/menuLinkTrimmer";

import { gotoDictWithWrappedLink } from "utils/dictUtil";

import AlertConfirmPopup from "components/common/AlertConfirmPopup";

import getUrlWithFromCd from "utils/getUrlWithFromCd";
import useXAPI from "store/customHooks/usexAPI";
import { useGoStarShop } from "utils/useGoStarShop";
import { getUrlPathname, getUrlPathnameAndSearch } from "utils/url";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";
import { setXAPIPath } from "../../utils/localStorage";
import useMemberShip from "store/customHooks/useMemberShip";

export const HandlerContext = React.createContext({
    clickMenuTypeCodePOP: () => {},
    clickMenuTypeCodePOPF: () => {},
    clickMenuTypeCodeLINK: () => {},
    clickMenuTypeCodeAPP: () => {},
    clickExitAppButton: () => {},
    clickMenuTypeCodeEXT_LINK: () => {},
});

const lnbNotShowingPlatformType = ["StudyRoom"];

function LnbWrapper({
    children,
    nowUrl,
    mmbrId,
    pedcCd,
    mmbrSeq,
    platformType,
    curseType,
    isLnbActiveTab,
    setIsLnbActiveTab,
    isForceLnbActiveTab,
    hasGnb = true,
    hasLnb = true,
}) {
    const contractNumber = useSelector((state) => state.loginReducer.contractNumber);
    const customerNumber = useSelector((state) => state.loginReducer.customerNumber);

    const history = useHistory();
    const location = useLocation();
    const gotoStarShop = useGoStarShop();

    const [isLnbOpen, setIsLnbOpen] = useState(false);
    const [isLnbHasNewAlert, setIsLnbHasNewAlert] = useState(false);
    const [lnbInfo, setLnbInfo] = useState([]);

    const [drawerList, setDrawerList] = useState([]);
    const [editDrawerList, setEditDrawerList] = useState([]);

    const today = getFormatDate();
    const userId = useSelector((state) => state.loginReducer.userId);
    const { ServiceUnit_A } = useXAPI();

    const pathCode = useRef("LTMN");

    // LNB에서 메뉴를 보여줄지 편집을 보여줄지 설정하는 state
    const [isListActive, setIsListActive] = useState(true);

    const lnbRef = useRef(null);

    const { ckLTAL, ckLTAL_ALTB, ckALTB } = useMemberShip();

    const LTAL = ckLTAL();
    const LTAL_ALTB = ckLTAL_ALTB();
    const ALTB = ckALTB();

    // LNB 정보 불러오기
    useEffect(() => {
        callGetLnbInfo();
    }, []);

    useEffect(() => {
        closeLnb();
    }, [location]);

    useEffect(() => {
        callDrawerInfo();
        initCloseWhenScroll();
    }, []);

    useEffect(() => {
        if (isLnbOpen) {
            lnbScrollTop();
            callDrawerInfo();
        }
    }, [isLnbOpen]);

    useEffect(() => {
        // console.log("[editDrawerList]", editDrawerList);
        initCallbackConfirmChangeDrawerListSort();

        return removeCallbackConfirmChangeDrawerListSort;
    }, [editDrawerList]);

    useEffect(() => {
        // console.log("platformType", platformType);
        const isLnbNotShowingPlatfromType = lnbNotShowingPlatformType.indexOf(platformType) === -1;
        const isUrlExistInDrawerInfo = lnbInfo.find(
            (info) => info.PGM_URL.split("?")[0] === nowUrl.split("?")[0] && info.DRWR_USE_YN === "Y",
        );

        setIsLnbActiveTab(
            !isForceLnbActiveTab &&
                (nowUrl === "/" || isUrlExistInDrawerInfo) &&
                (isLnbNotShowingPlatfromType || curseType !== "SINGLE") &&
                !(LTAL || LTAL_ALTB || ALTB) // 라이트, 단과목 이용권 제외
                ? true
                : false,
        );
    }, [nowUrl, lnbInfo, platformType, curseType, isForceLnbActiveTab]);

    const lnbScrollTop = () => {
        if (lnbRef) {
            lnbRef.current.scrollTo(0, 0);
        }
    };

    const toggleLnb = () => {
        setIsLnbOpen(!isLnbOpen);
        setIsListActive(true);
    };

    const closeLnb = () => {
        setIsLnbOpen(false);
        setIsListActive(true);
    };

    const toggleList = () => {
        setIsListActive(!isListActive);
    };

    const initCloseWhenScroll = () => {
        window.addEventListener("scroll", closeWhenScroll);
    };

    const closeWhenScroll = () => {
        closeLnb();
    };

    const closeAppAlert = () => {
        const confirmParam = {
            type: "CONFIRM",
            title: "알림",
            msg: "스마트올 중학 서비스를<br />나가시겠습니까?",
            buttonInfo: [
                {
                    title: "확인",
                    value: true,
                },
                {
                    title: "취소",
                    value: false,
                },
            ],
        };

        AlertConfirmPopup(confirmParam).then((response) => {
            if (response) {
                closeApp();
            }
        });
    };

    const callDrawerInfo = () => {
        const headerParam = {
            user_id: mmbrId,
        };

        const queryParam = {
            MMBR_SEQ: mmbrSeq,
            PEDC_CD: pedcCd,
        };

        const param = {
            REQUEST_API: Constants.MID_STUDY_API.DRAWER_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(headerParam, param, callbackDrawerInfo, queryParam);
    };

    const callbackDrawerInfo = (response) => {
        const drawerList = response?.RESP_RESULT?.DRWR_LIST;

        if (drawerList) {
            setDrawerList(drawerList);
            setEditDrawerList(drawerList);
            setIsLnbHasNewAlertIfAlertExist(drawerList);
        }
    };

    const setIsLnbHasNewAlertIfAlertExist = (drawerList) => {
        const noticeInfo = drawerList.find((info) => info.DRWR_CD === "NOTI");

        if (noticeInfo?.SUB_DRWR?.length > 0) {
            setIsLnbHasNewAlert(true);
            return;
        }
        setIsLnbHasNewAlert(false);
    };

    const makePopLink = (UP_MENU_CD, link) => {
        if (UP_MENU_CD === "MYSTD") {
            return getUrlPathname(link);
        }

        return getUrlPathnameAndSearch(link);
    };

    const clickMenuTypeCodePOP = ({ LINK, MENU_URL, UP_MENU_CD, MENU_CD }, DRWR_CD = null) => {
        setXAPIPath("L");
        const link = LINK || MENU_URL;
        history.push(getUrlWithFromCd(menuLinkTrimmer(link), pathCode.current, UP_MENU_CD, MENU_CD));

        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, makePopLink(UP_MENU_CD, link));
        closeLnb();
    };

    const clickMenuTypeCodePOPF = ({ LINK, MENU_URL, UP_MENU_CD, MENU_CD }, DRWR_CD = null) => {
        setXAPIPath("L");
        const link = LINK || MENU_URL;
        history.push(getUrlWithFromCd(menuLinkTrimmer(link), pathCode.current, UP_MENU_CD, MENU_CD));

        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, getUrlPathnameAndSearch(link));
        closeLnb();
    };

    const clickMenuTypeCodeLINK = ({ LINK, MENU_URL, UP_MENU_CD, MENU_CD }, DRWR_CD = null) => {
        setXAPIPath("L");
        const link = LINK || MENU_URL;
        if (link) {
            history.push(getUrlWithFromCd(menuLinkTrimmer(link), pathCode.current, UP_MENU_CD, MENU_CD));

            closeLnb();
            if (DRWR_CD === "NSTD") {
                // "최근 학습하지 않은 강의"
                ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, getUrlPathname(link));
            } else {
                ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, getUrlPathnameAndSearch(link));
            }
        }
    };

    const clickMenuTypeCodeEXT_LINK = ({ LINK, MENU_URL, UP_MENU_CD, MENU_CD }, DRWR_CD = null) => {
        setXAPIPath("L");
        const link = LINK || MENU_URL;

        if (link && link.indexOf("star-shop") !== -1) {
            gotoStarShop();
        } else if (link && link.indexOf("wjdict") === -1) {
            history.push(getUrlWithFromCd(link, pathCode.current, UP_MENU_CD, MENU_CD));
        } else {
            ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, getUrlPathnameAndSearch(link));
            gotoDictWithWrappedLink(link, "NEW_VIEW", {
                contractNumber: contractNumber,
                customerNumber: customerNumber,
                exhibitionTp: "MID_LNB",
            });
        }
        closeLnb();
    };

    const clickExitAppButton = () => {
        closeAppAlert();
    };

    const clickMenuTypeCodeAPP = (link, DRWR_CD = null) => {
        if (link) {
            const param = {
                PGM_URL: link.LINK,
                PGM_SCRN_TY: "APP",
                PGM_NAME: link.NAME,
            };

            ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0003, getUrlPathnameAndSearch(link));
            launchWebView(param, history);
        }
    };

    const changeItemIndex = (indexBeReplaced) => {
        console.log(indexBeReplaced);
        setEditDrawerList(indexBeReplaced);
    };

    const changeEditDrawerListToOriginalDrawerList = () => {
        setEditDrawerList(drawerList);
    };

    const callConfirmChangeDrawerListSort = () => {
        if (drawerList !== editDrawerList) {
            const confirmParam = {
                type: "CONFIRM",
                title: "순서 변경",
                msg: "변경된 순서로 저장하시겠습니까?",
                button: [
                    {
                        title: "확인",
                        value: true,
                    },
                    {
                        title: "취소",
                        value: false,
                    },
                ],
            };

            AlertConfirmPopup(confirmParam).then((response) => {
                if (response) {
                    changeDrawerListSort();
                }
            });
            return;
        }
        toggleList();
    };

    const initCallbackConfirmChangeDrawerListSort = () => {
        // console.log("[initCallbackConfirmChangeDrawerListSort]", editDrawerList);

        window.callbackConfirmChangeDrawerListSort = (response) => {
            // console.log("window.callbackConfirmChangeDrawerListSort", editDrawerList);
            if (response === "true") {
                changeDrawerListSort();
            }
        };
    };

    const removeCallbackConfirmChangeDrawerListSort = () => {
        window.callbackConfirmChangeDrawerListSort = null;
    };

    const changeDrawerListSort = () => {
        // drawerList를 변경된 drawerList로 변경
        setDrawerList(editDrawerList);
        toggleList();

        // 서버에 DSP_NO 변경 요청
        callSaveChangeDrawerListIndex();
    };

    const getChangedDrawerList = () => {
        let drawerBody = [];

        console.log("editDrawerList", editDrawerList);
        editDrawerList.forEach((info, idx) => {
            drawerBody.push({
                DRWR_PEDC_MPNG_SEQ: info.DRWR_PEDC_MPNG_SEQ,
                DRWR_NO: idx + 1,
            });
        });
        console.log("drawerBody", drawerBody);

        return {
            DRAW_LIST: drawerBody,
        };
    };
    const callSaveChangeDrawerListIndex = () => {
        const headerParam = {
            user_id: mmbrId,
        };
        const queryParam = {
            USER_SEQ: mmbrSeq,
        };
        const param = {
            REQUEST_API: Constants.MID_STUDY_API.CHANGE_DRAWER_LIST_INDEX,
            HTTP_METHOD: Constants.HTTP_METHOD.POST,
            BODY: getChangedDrawerList(),
        };

        callPost(headerParam, param, null, queryParam);
    };

    // LNB 열었을 때 실행한다.
    const callEmptyAlert = () => {
        const headerParam = {
            user_id: mmbrId,
        };
        const queryParam = {
            MMBR_SEQ: mmbrSeq,
            PEDC_CD: pedcCd,
        };
        const body = {
            CNFR_YN: "Y",
        };
        const param = {
            REQUEST_API: Constants.MID_STUDY_API.EMPTY_NOTICE,
            HTTP_METHOD: Constants.HTTP_METHOD.PUT,
            BODY: body,
        };
        callPost(headerParam, param, callbackEmptyAlert, queryParam);
    };

    const callbackEmptyAlert = () => {
        setIsLnbHasNewAlert(false);
    };

    // LNB 페이지 여부 정보 조회
    const callGetLnbInfo = () => {
        const headerParam = {
            user_id: mmbrId,
        };

        const queryParam = {};

        const param = {
            REQUEST_API: Constants.MID_STUDY_API.PRGM_INFO,
            // REQUEST_API: "/midStudy/v1.0/common/prgmInfo1",

            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(headerParam, param, callbackGetLnbInfo, queryParam);
    };

    const callbackGetLnbInfo = (response) => {
        const lnbInfo = response?.RESP_RESULT?.PGRM_LIST;

        if (lnbInfo) {
            setLnbInfo(lnbInfo);
        }
    };

    const movePageHandlers = useMemo(
        () => ({
            clickMenuTypeCodePOP,
            clickMenuTypeCodePOPF,
            clickMenuTypeCodeLINK,
            clickMenuTypeCodeAPP,
            clickExitAppButton,
            clickMenuTypeCodeEXT_LINK,
        }),
        [
            clickMenuTypeCodePOP,
            clickMenuTypeCodePOPF,
            clickMenuTypeCodeLINK,
            clickMenuTypeCodeAPP,
            clickExitAppButton,
            clickMenuTypeCodeEXT_LINK,
        ],
    );

    return (
        <HandlerContext.Provider value={movePageHandlers}>
            <LnbMainWrapper isLnbOpen={isLnbOpen && hasLnb} isLnbActive={isLnbActiveTab} hasGnb={hasGnb}>
                {/* 서랍 메뉴를 쓰지 않는 화면(신규 홈)에서는 메뉴와 토글 버튼을 그리지 않는다. */}
                {hasLnb && (
                    <Fl>
                        <Menu
                            drawerList={drawerList}
                            editDrawerList={editDrawerList}
                            changeItemIndex={changeItemIndex}
                            callConfirmChangeDrawerListSort={callConfirmChangeDrawerListSort}
                            changeEditDrawerListToOriginalDrawerList={changeEditDrawerListToOriginalDrawerList}
                            isListActive={isListActive}
                            toggleList={toggleList}
                            platformType={platformType}
                            callEmptyAlert={callEmptyAlert}
                            lnbRef={lnbRef}
                        />
                        <ToggleButton
                            isLnbHasNewAlert={isLnbHasNewAlert}
                            isLnbActive={isLnbActiveTab}
                            isLnbOpen={isLnbOpen}
                            toggleLnb={toggleLnb}
                        />
                    </Fl>
                )}
                <FlContent>{children}</FlContent>
            </LnbMainWrapper>
        </HandlerContext.Provider>
    );
}

export default LnbWrapper;
